var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zhiji-service-page",attrs:{"id":"zhiji-service-page"}},[(_vm.isInited)?_c('router-view'):_vm._e(),_c('Modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }